/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Status_PendingInputs */

const id_profile_status_pending = /** @type {(inputs: Profile_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu persetujuan`)
};

const en_profile_status_pending = /** @type {(inputs: Profile_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting approval`)
};

/**
* | output |
* | --- |
* | "Awaiting approval" |
*
* @param {Profile_Status_PendingInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_status_pending = /** @type {((inputs?: Profile_Status_PendingInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Status_PendingInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_status_pending(inputs)
	return id_profile_status_pending(inputs)
});